import { render, staticRenderFns } from "./jenisiklandigital.vue?vue&type=template&id=15a349e0"
import script from "./jenisiklandigital.vue?vue&type=script&lang=js"
export * from "./jenisiklandigital.vue?vue&type=script&lang=js"
import style0 from "./jenisiklandigital.vue?vue&type=style&index=0&id=15a349e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports